import { apiClient } from '../../../app/api/apiClient';
import type {
  CreateServiceInput,
  Service,
  UpdateServiceInput,
} from '../types/service.types';

interface ServiceEnvelope<T> {
  success: boolean;
  data: T;
}

export async function listServices(tenantId?: number): Promise<Service[]> {
  const response = await apiClient.get('/api/super-admin/services', {
    ...(tenantId === undefined ? {} : { query: { tenant_id: tenantId } }),
  });
  const envelope = response.data as ServiceEnvelope<{ services: Service[] }>;
  return envelope.data.services;
}

export async function getService(id: string | number): Promise<Service> {
  const response = await apiClient.get(`/api/super-admin/services/${id}`);
  const envelope = response.data as ServiceEnvelope<{ service: Service }>;
  return envelope.data.service;
}

export async function createService(input: CreateServiceInput): Promise<Service> {
  const response = await apiClient.post('/api/super-admin/services', input);
  const envelope = response.data as ServiceEnvelope<{ service: Service }>;
  return envelope.data.service;
}

export async function updateService(
  id: string | number,
  input: UpdateServiceInput,
): Promise<Service> {
  const response = await apiClient.patch(`/api/super-admin/services/${id}`, input);
  const envelope = response.data as ServiceEnvelope<{ service: Service }>;
  return envelope.data.service;
}

export async function archiveService(
  id: string | number,
  tenantId: number,
): Promise<Service> {
  const response = await apiClient.post(
    `/api/super-admin/services/${id}/archive`,
    { tenant_id: tenantId },
  );
  const envelope = response.data as ServiceEnvelope<{ service: Service }>;
  return envelope.data.service;
}
